<template>
  <div>
    <v-layout wrap v-if="!hideMain">
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs12 class="px-1 mt-3 mb-1">
            <Typography h5 bold color="color-darkBlue" :label="$t('Member info')" />
          </v-flex>
          <v-flex xs12 sm12 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('Email')" />
            <input
              type="text"
              :placeholder="$t('Email')"
              v-model.lazy="filter.email"
              class="form-broadcast"
              maxlength="255"
            />
          </v-flex>
          <v-flex xs12 sm12 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('phone no.')" />
            <input
              type="text"
              placeholder="Phone No"
              v-model.lazy="filter.phoneno"
              class="form-broadcast"
              maxlength="255"
            />
          </v-flex>
          <v-flex xs12 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('Select Member type')" />
            <div class="form-broadcast" :class="{ 'has-error': errors.has('ประเภทสมาชิก') }">
              <multiselect
                class="form-broadcast"
                v-model="filter.membertype"
                :options="customerMembertypeOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                :placeholder="$t('select member type')"
              ></multiselect>

              <p class="text-error" v-if="errors.has('ประเภทสมาชิก')">
                {{ errors.first('ประเภทสมาชิก') }}
              </p>
            </div></v-flex
          >
          <v-flex xs12 sm12 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('Project')" />
            <div class="form-broadcast" :class="{ 'has-error': errors.has('Project') }">
              <multiselect
                class="form-broadcast"
                v-model="filter.projectname"
                :options="customerProjectOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                :placeholder="$t('select project')"
              ></multiselect>

              <p class="text-error" v-if="errors.has('Project')">{{ errors.first('Project') }}</p>
            </div></v-flex
          >
          <v-flex xs12 sm12 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('Project type')" />
            <div class="form-broadcast" :class="{ 'has-error': errors.has('Context') }">
              <multiselect
                class="form-broadcast"
                v-model="filter.projecttype"
                :options="projectTypeOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                :placeholder="$t('select project type')"
              ></multiselect>

              <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
            </div>
          </v-flex>
          <!-- <v-flex xs12 sm6 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('Status')" />
            <div class="form-broadcast" :class="{ 'has-error': errors.has('Status') }">
              <multiselect
                class="form-broadcast"
                v-model="filter.memberstatus"
                :options="customerStatusOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                :placeholder="$t('select status')"
                :customLabel="customLabelMemberStatus"
              >
              </multiselect>

              <p class="text-error" v-if="errors.has('Status')">{{ errors.first('Status') }}</p>
            </div></v-flex
          > -->
          <v-flex xs12 sm6 class="pa-1">
            <Typography h5 semiBold color="color-darkGrey" :label="$t('DP type')" />
            <div class="form-broadcast" :class="{ 'has-error': errors.has('DP type') }">
              <multiselect
                class="form-broadcast"
                v-model="filter.dpType"
                :options="['DP', 'Non-DP']"
                :searchable="false"
                selectLabel
                selectedLabel
                :placeholder="$t('select dp type')"
                deselect-label
              >
              </multiselect>

              <p class="text-error" v-if="errors.has('DP type')">{{ errors.first('DP type') }}</p>
            </div></v-flex
          >
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 class="pa-1" :class="{ 'has-error': errorFilterTag.length > 0 }">
        <Typography h5 bold color="color-darkBlue" :label="$t('Tag')" />
        <tags
          class="form-broadcast"
          v-model="tag"
          :tags="tags"
          @tags-changed="addTags"
          @before-adding-tag="checkTag"
          style="margin-bottom: 10px"
          :btnText="$t('Add tag')"
          :isDrag="false"
        ></tags>

        <span class="text-error" v-if="errorFilterTag.length > 0">
          <template v-if="errorFilterTag.includes('overmaxlength')">{{
            $t('Message cannot be longer than 20 alphabets')
          }}</template>
          <template v-else-if="errorFilterTag.includes('duplicate')">{{
            $t('Duplicate Tag')
          }}</template>
        </span>
      </v-flex>
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-2">
      <slot></slot>
      <!-- <v-flex xs12 class="pa-1 mt-1">
        <div
          style="text-align: right; color: black; font-size: 1.1em"
        >{{$t('Total')}}: {{total_user}}</div>
      </v-flex>-->
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import Tags from '@/components/elements/TagsBroadcast'
import Typography from '@/components/elements/Typography'

export default {
  props: {
    value: {
      default: undefined,
    },
    hideMain: {
      default: false,
    },
    filterType: {
      default: null,
    },
  },
  components: {
    Multiselect,
    datepicker,
    Tags,
    Typography,
  },

  mounted: function () {
    this.getIntent()
    this.getdepaproject()
    this.getdepamembertypeall()
    this.getProjectType()
    this.getGender()
    this.getChannel()
    //this.$emit('onUpdate')
  },
  data: function () {
    return {
      customerStatusOptions: ['confirm', 'unconfirmed'],
      customerProjectOptions: [],
      customerMembertypeOptions: [],
      isLoading: false,
      filter: this.value,
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all',
        },
        {
          label: this.$t('Line'),
          value: 'line',
        },
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all',
        },
        {
          label: this.$t('Male'),
          value: 'male',
        },
        {
          label: this.$t('Female'),
          value: 'female',
        },
        {
          label: this.$t('no gender'),
          value: 'other',
        },
      ],
      specialconditionOptions: [
        {
          label: this.$t('Active Users'),
          value: 'activeusers',
        },
        {
          label: this.$t('Potential Users'),
          value: 'potentialusers',
        },
        {
          label: this.$t('Purchased Users'),
          value: 'perchasedusers',
        },
        {
          label: this.$t('Loyal Customer'),
          value: 'perchasedusers_royalty',
        },
        {
          label: this.$t('New Customer'),
          value: 'perchasedusers_newcomer',
        },
      ],
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than'),
        },
        {
          value: 'l__',
          label: this.$t('Less than'),
        },
        {
          value: 'n__',
          label: this.$t('Not'),
        },
      ],
      intents: [],
      errorFilterTag: [],
      tag: '',
      depaprojects: [],
      projectTypeOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
    }),
    langFilter() {
      if (this.filterType === 'boardcast') {
        let data = [
          {
            title: 'Thai',
            value: 'th_TH',
            icon: 'th',
          },
          {
            title: 'English (US)',
            value: 'en_US',
            icon: 'us',
          },
        ]
        return data
      } else {
        return config.locale
      }
    },
    filterIntent: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function (index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      },
    },
  },

  methods: {
    customLabelMemberStatus(opt) {
      if (opt == 'confirm') return 'ยืนยันตัวตนแล้ว'
      else if (opt == 'unconfirmed') return 'ยังไม่ยืนยันตัวตน'
    },
    getProjectType() {
      return new Promise((resolve) => {
        api.getdepaprojecttype(this.search, (err, response) => {
          if (response.responsecode == 200) {
            this.projectTypeOptions = response.data.map((el) => {
              return el.typename
            })
          }
          resolve()
        })
      })
    },
    getdepamembertypeall() {
      api.getdepamembertypeall({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          this.customerMembertypeOptions = response.data.map((el) => el.type)
        }
      })
    },
    getdepaproject() {
      return new Promise((resolve) => {
        api.getdepaproject({}, (err, response) => {
          if (response.responsecode == 200) {
            this.customerProjectOptions = response.data.map((el) => el.projectname)
          }
          resolve()
        })
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    getChannel: function(){
      this.channelOptions.map(item=> {
        if(this.filter.app === item.value){
          this.filter.app = item
        }
      })
    },
    getGender: function(){
      this.genderOptions.map(item=> {
        if(this.filter.gender === item.value){
          this.filter.gender = item
        }
      })
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
        }
        api.getIntent(data, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response.data) {
            var isFoundDefault = false
            var intents = []
            $.each(response.data, function (index, val) {
              var intent = val
              intent.isShow = false
              intents.push(intent)
            })
            vm.intents = intents
          }
          resolve()
        })
      })
    },
    onActiveStartDate: function (value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
      this.$emit('onUpdate')
    },
    onActiveEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
      this.$emit('onUpdate')
    },
    onRegisterStartDate: function (value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
      this.$emit('onUpdate')
    },
  },
  watch: {
    value: function (newVal) {
      this.filter = newVal
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterBroadcast.vue